module.exports = __webpack_public_path__ + "static/media/upgrade_remote_icon.8c12eba8.svg";